export function getLocaleFromUrl(url: string): string {
  const localeMatch = url.match(/^\/(ua|en|pl|ro|hr|el|bg|lt|it|hu)/);
  if (localeMatch) {
    return localeMatch[1] === "ua" ? "uk" : localeMatch[1];
  }
  return "en";
}

export function buildArticlePageQuery(slug: string, locale?: string): string {
  const localeParam = locale ? `&locale=${locale}` : "";
  return `/api/articles?customPopulate=nested&status=preview&countView=true&filters[slug][$eq]=${slug}${localeParam}`;
}

export function buildNewsForUkrainePageQuery(
  slug: string,
  locale: string,
): string {
  return `/api/news-for-ukraines?customPopulate=nested&status=preview&countView=true&filters[slug][$eq]=${slug}&locale=${locale}`;
}

export function buildTeamMemberQuery(slug: string, locale?: string): string {
  const localeParam = locale ? `&locale=${locale}` : "";
  return `/api/team-members?customPopulate=nested&filters[slug][$eq]=${slug}${localeParam}`;
}

export function getQueriesForRoute(url: string): string[] {
  const queries: string[] = [];

  let locale = "";
  let slug = "";

  const localeMatch = url.match(/^\/(ua|en|pl|ro|hr|el|bg|lt|it|hu)/);
  if (localeMatch) {
    locale = localeMatch[1] === "ua" ? "uk" : localeMatch[1];
  }

  if (
    locale === "uk" ||
    locale === "pl" ||
    locale === "ro" ||
    locale === "hr" ||
    locale === "el" ||
    locale === "bg" ||
    locale === "lt" ||
    locale === "it" ||
    locale === "hu"
  ) {
    queries.push(`/api/global-ukraine?customPopulate=nested&locale=${locale}`);
  } else {
    queries.push("/api/global?customPopulate=nested");
  }

  if (url === "/" || url === "") {
    queries.push("/api/homepage?customPopulate=nested");
  } else if (url.match(/^\/(ua|en|pl|ro|hr|el|bg|lt|it|hu)\/?$/)) {
    queries.push(
      `/api/homepage-ukraine?customPopulate=nested&locale=${locale}`,
    );
  } else if (url === "/news" || url === "/news/") {
    queries.push("/api/news-international?customPopulate=nested");
  } else if (url.match(/^\/(pl|ro|hr|el|bg|lt|it|hu)\/news\/?$/)) {
    queries.push(
      `/api/news-international?customPopulate=nested&locale=${locale}`,
    );
  } else if (url.match(/^\/(ua|en)\/news\/?$/)) {
    queries.push(`/api/news-ukraine?customPopulate=nested&locale=${locale}`);
  } else if ((slug = url.match(/^\/news\/([^/]+)\/?$/)?.[1] || "")) {
    queries.push(buildArticlePageQuery(slug));
  } else if (
    (slug =
      url.match(/^\/(pl|ro|hr|el|bg|lt|it|hu)\/news\/([^/]+)\/?$/)?.[2] || "")
  ) {
    queries.push(buildArticlePageQuery(slug, locale));
  } else if (url.match(/^\/(ua|en)\/news\/([^/]+)\/?$/)?.[2]) {
    slug = url.match(/^\/(ua|en)\/news\/([^/]+)\/?$/)?.[2] || "";
    queries.push(buildNewsForUkrainePageQuery(slug, locale));
  } else if ((slug = url.match(/^\/team\/([^/]+)\/?$/)?.[1] || "")) {
    queries.push(buildTeamMemberQuery(slug));
  } else if (
    (slug =
      url.match(/^\/(ua|en|pl|ro|hr|el|bg|lt|it|hu)\/team\/([^/]+)\/?$/)?.[2] ||
      "")
  ) {
    queries.push(buildTeamMemberQuery(slug, locale));
  } else if ((slug = url.match(/^\/products\/([^/]+)\/?$/)?.[1] || "")) {
    queries.push(
      `/api/product-internationals?customPopulate=nested&status=preview&filters[slug][$eq]=${slug}`,
    );
  } else if (
    (slug =
      url.match(
        /^\/(ua|en|pl|ro|hr|el|bg|lt|it|hu)\/products\/([^/]+)\/?$/,
      )?.[2] || "")
  ) {
    queries.push(
      `/api/product-ukraines?customPopulate=nested&status=preview&filters[slug][$eq]=${slug}&locale=${locale}`,
    );
  } else if (url === "/esg" || url === "/esg/") {
    queries.push("/api/esg-international?customPopulate=nested&locale=en");
  } else if (url === "/esg_test" || url === "/esg_test/") {
    queries.push("/api/esg-international?customPopulate=nested&locale=en");
  } else if (url.match(/^\/(ua|en|pl|ro|hr|el|bg|lt|it|hu)\/esg\/?$/)) {
    queries.push(`/api/esg-ukraine?customPopulate=nested&locale=${locale}`);
  } else if (url.match(/^\/(ua|en|pl|ro|hr|el|bg|lt|it|hu)\/esg_test\/?$/)) {
    queries.push(`/api/esg-ukraine?customPopulate=nested&locale=${locale}`);
  } else if ((slug = url.match(/^\/page\/([^/]+)\/?$/)?.[1] || "")) {
    queries.push(
      `/api/esg-ukraines?filters[slug][$eq]=${slug}&customPopulate=nested&locale=en`,
    );
  } else if (
    (slug =
      url.match(/^\/(ua|en|pl|ro|hr|el|bg|lt|it|hu)\/page\/([^/]+)\/?$/)?.[2] ||
      "")
  ) {
    queries.push(
      `/api/esg-ukraines?filters[slug][$eq]=${slug}&customPopulate=nested&locale=${locale}`,
    );
  } else if (url === "/regulatory" || url === "/regulatory/") {
    queries.push("/api/regulatory?customPopulate=nested");
  } else if (url.match(/^\/(ua|en|pl|ro|hr|el|bg|lt|it|hu)\/regulatory\/?$/)) {
    queries.push(
      `/api/regulatory-ukraine?customPopulate=nested&locale=${locale}`,
    );
  } else if (
    url.match(/^\/(ua|en|pl|ro|hr|el|bg|lt|it|hu)\/regulatory-dtrading\/?$/)
  ) {
    queries.push(
      `/api/regulatory-dtrading?customPopulate=nested&locale=${locale}`,
    );
  } else if (
    url.match(/^\/(ua|en|pl|ro|hr|el|bg|lt|it|hu)\/regulatory_tmp\/?$/)
  ) {
    queries.push(
      `/api/regulatory-ukraine?customPopulate=nested&locale=${locale}`,
    );
  } else if (url.match(/^\/(ua|en|pl|ro|hr|el|bg|lt|it|hu)\/info\/?$/)) {
    queries.push(`/api/info-ukraine?customPopulate=nested&locale=${locale}`);
  } else if (url === "/careers" || url === "/careers/") {
    queries.push("/api/career?customPopulate=nested");
  } else if (url.match(/^\/(ua|en|pl|ro|hr|el|bg|lt|it|hu)\/careers\/?$/)) {
    queries.push(`/api/career-ukraine?customPopulate=nested&locale=${locale}`);
  } else if (
    url.match(/^\/(ua|en|pl|ro|hr|el|bg|lt|it|hu)\/careers-dtrading\/?$/)
  ) {
    queries.push(`/api/career-dtrading?customPopulate=nested&locale=${locale}`);
  } else if ((slug = url.match(/^\/([^/]+)\/?$/)?.[1] || "")) {
    if (
      ![
        "news",
        "products",
        "esg",
        "esg_test",
        "regulatory",
        "careers",
        "team",
      ].includes(slug)
    ) {
      queries.push(
        `/api/pages?customPopulate=nested&filters[slug][$eq]=${slug}`,
      );
    }
  } else if (
    (slug =
      url.match(/^\/(ua|en|pl|ro|hr|el|bg|lt|it|hu)\/([^/]+)\/?$/)?.[2] || "")
  ) {
    if (
      ![
        "news",
        "products",
        "esg",
        "esg_test",
        "regulatory",
        "regulatory-dtrading",
        "regulatory_tmp",
        "careers",
        "careers-dtrading",
        "info",
        "team",
      ].includes(slug)
    ) {
      queries.push(
        `/api/pages?customPopulate=nested&filters[slug][$eq]=${slug}&locale=${locale}`,
      );
    }
  }

  return queries;
}

export function getPageQueryForRoute(url: string): string | undefined {
  const queries = getQueriesForRoute(url);
  return queries.find((query) => !query.includes("/api/global"));
}

export const ALTERNATE_LINK_FALLBACK_LOCALES = [
  "en",
  "hr",
  "ro",
  "pl",
  "el",
  "bg",
  "lt",
  "it",
  "hu",
] as const;

export function getAlternateLinkFallbackQueries(pathname: string): string[] {
  const pageQuery = getPageQueryForRoute(pathname);
  if (!pageQuery) {
    return [];
  }

  const currentLocale = getLocaleFromUrl(pathname);
  const otherLocales = ALTERNATE_LINK_FALLBACK_LOCALES.filter(
    (locale) => locale !== currentLocale,
  );

  if (pageQuery.startsWith("/api/homepage?")) {
    return otherLocales.map(
      (locale) =>
        `/api/homepage-ukraine?customPopulate=nested&locale=${locale}`,
    );
  }

  if (pageQuery.startsWith("/api/news-international?")) {
    return otherLocales.map(
      (locale) =>
        `/api/news-international?customPopulate=nested&locale=${locale}`,
    );
  }

  if (pageQuery.startsWith("/api/esg-international?")) {
    return otherLocales.map(
      (locale) => `/api/esg-ukraine?customPopulate=nested&locale=${locale}`,
    );
  }

  if (pageQuery.startsWith("/api/regulatory?")) {
    return otherLocales.map(
      (locale) =>
        `/api/regulatory-ukraine?customPopulate=nested&locale=${locale}`,
    );
  }

  if (pageQuery.startsWith("/api/career?")) {
    return otherLocales.map(
      (locale) => `/api/career-ukraine?customPopulate=nested&locale=${locale}`,
    );
  }

  if (/locale=[a-z]{2}/.test(pageQuery)) {
    return otherLocales.map((locale) =>
      pageQuery.replace(/locale=[a-z]{2}/, `locale=${locale}`),
    );
  }

  if (
    pageQuery.includes("/api/articles?") ||
    pageQuery.includes("/api/product-internationals?") ||
    pageQuery.includes("/api/pages?")
  ) {
    const separator = pageQuery.includes("?") ? "&" : "?";
    return otherLocales
      .filter((locale) => locale !== "en")
      .map((locale) => `${pageQuery}${separator}locale=${locale}`);
  }

  return [];
}

const SINGLE_TYPE_APIS = [
  "/api/homepage?",
  "/api/homepage-ukraine?",
  "/api/news-international?",
  "/api/news-ukraine?",
  "/api/esg-international?",
  "/api/esg-ukraine?",
  "/api/regulatory?",
  "/api/regulatory-ukraine?",
  "/api/regulatory-dtrading?",
  "/api/info-ukraine?",
  "/api/career?",
  "/api/career-ukraine?",
  "/api/career-dtrading?",
];

export function isPageNotFoundForRoute(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pageData: any,
  pageQuery?: string,
): boolean {
  if (!pageQuery) {
    return false;
  }

  const isSingleType = SINGLE_TYPE_APIS.some((prefix) =>
    pageQuery.startsWith(prefix),
  );

  if (isSingleType) {
    if (!pageData?.data) {
      return true;
    }

    if (pageQuery.includes("/api/esg-")) {
      return !pageData.data.Blocks?.length;
    }

    return false;
  }

  return Array.isArray(pageData?.data) && pageData.data.length === 0;
}
